import { render, staticRenderFns } from "./standardBreadcrumb.vue?vue&type=template&id=768937d0&"
import script from "./standardBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./standardBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports